import Bowser from "bowser";

export const isValidBrowser = (): boolean | undefined => {
  const output = Bowser.parse(window.navigator.userAgent);
  return output.platform.type === "desktop" && output.browser.name === "Chrome";
};
